import { render, staticRenderFns } from "./AveragePerSupplierByAirport.vue?vue&type=template&id=5159c895&scoped=true&"
import script from "./AveragePerSupplierByAirport.vue?vue&type=script&lang=js&"
export * from "./AveragePerSupplierByAirport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5159c895",
  null
  
)

export default component.exports